// This file is auto-generated, any changes you make may be overridden
// You should use src/mercuryWebCompat/pages/Treasury/Onboarding/utils.ts to access these values
import {type GeneratedCusip, type TreasuryOnboardingData} from './types'
import {Day} from '~/utils/Calendar'

export const generatedPortfolioData: Record<
  GeneratedCusip | '4812C2734',
  TreasuryOnboardingData
> = {
  // Morgan Stanley MULSX
  '617455696': {
    fundSize: `$13.5B`,
    maturity: `76 days`,
    netYieldPct: 3.714,
    grossYieldPct: 4.58,
    mercuryFeePct: 0.866,
    composition: [
      ['Corporate Notes', 35.77],
      ['Commercial Paper', 28.27],
      ['Repurchase Agreements', 19.03],
      ['Certificates of Deposit', 16.93],
    ],
    updatedAt: new Day(2025, 4, 28),
  },
  // Vanguard VUSXX
  '921932109': {
    fundSize: `$92.4 B`,
    maturity: `42 days`,
    netYieldPct: 3.364,
    grossYieldPct: 4.23,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Bills', 97.4],
      ['U.S. Govt. Obligations', 2.6],
    ],
    updatedAt: new Day(2025, 4, 28),
  },
  // JPMorgan IJTXX
  '4812C2734': {
    fundSize: `$45.36B`,
    maturity: `41 days`,
    netYieldPct: 3.364,
    grossYieldPct: 4.23,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Repurchase Agreement', 51.4],
      ['U.S. Treasury Debt', 48.6],
    ],
    updatedAt: new Day(2025, 4, 28),
  },
} as const
